// HomeSearchHistorySection.jsx
import React, { useState } from 'react';
import useSearchHistory from '../../../hooks/useSearchHistory';
import { getSearchById } from '../../../services/searchHistoryService';
import { useAuth } from '../../../context/AuthContext';
import HomeSearchHistory from './HomeSearchHistory';
import useSearchState from '../../../hooks/useSearch';
import useSearchHistoryById from "../../../hooks/useSearchHistoryById";

const HomeSearchHistorySection = () => {
  const {
    searchHistory,
    removeSearch: handleDeleteSearch,
    addSearch: handleSaveSearch,
    isLoading: isLoadingHistory,
  } = useSearchHistory();
  const { currentUser } = useAuth();

  const { selectPropertyFromHistory, updatePostCode, updateLoadingState, searchState } =
    useSearchState();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  const [searchLoading, setSearchLoading] = useState(false);

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  const searches = searchHistory || [];

  const filteredSearches = searches.filter(
    (search, index, self) =>
      index ===
      self.findIndex((s) => s.address === search.address && s.flat_number === search.flat_number),
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredSearches.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredSearches.length / itemsPerPage);
  const isPremiumUser = true

  const [searchId, setSearchId] = useState(null);


  const { data: dbSearchData } = useSearchHistoryById(searchId);


  const onDeleteSearch = (id) => {
    if (searchLoading) return;
    handleDeleteSearch(id);
  };

  const onClickSearch = async (search) => {
    console.log('Map search', search);
    let fullSearchData = search;
    setSearchId(search.id);

    await selectPropertyFromHistory(fullSearchData, search.id);
  };

  return (
    <HomeSearchHistory
      currentUser={currentUser}
      isLoadingHistory={isLoadingHistory}
      searchLoading={searchLoading}
      currentPage={currentPage}
      itemsPerPage={itemsPerPage}
      totalPages={totalPages}
      indexOfFirstItem={indexOfFirstItem}
      indexOfLastItem={indexOfLastItem}
      filteredSearches={filteredSearches}
      currentItems={currentItems}
      isPremiumUser={isPremiumUser}
      handlePageChange={handlePageChange}
      onDeleteSearch={onDeleteSearch}
      onClickSearch={onClickSearch}
    />
  );
};

export default HomeSearchHistorySection;
